var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"front",scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}],null,true)},[_c('v-container',{staticClass:"lang-HE front"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }